import React from "react"
import { RouteComponentProps } from "react-router"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import EntityActivation, {ActivationType} from './EntityActivation'

export default class PortalActivation extends React.Component {
  render = () => {
    return <AppPageWrapper showNav>
      <EntityActivation {...this.props as RouteComponentProps} type={ActivationType.Portal}/>
    </AppPageWrapper>
  }
}
